var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5569 12.906L16.1019 13.359C16.1019 13.359 15.0189 14.435 12.0639 11.497C9.10886 8.55898 10.1919 7.48298 10.1919 7.48298L10.4779 7.19698C11.1849 6.49498 11.2519 5.36698 10.6349 4.54298L9.37486 2.85998C8.61086 1.83998 7.13586 1.70498 6.26086 2.57498L4.69086 4.13498C4.25786 4.56698 3.96786 5.12498 4.00286 5.74498C4.09286 7.33198 4.81086 10.745 8.81486 14.727C13.0619 18.949 17.0469 19.117 18.6759 18.965C19.1919 18.917 19.6399 18.655 20.0009 18.295L21.4209 16.883C22.3809 15.93 22.1109 14.295 20.8829 13.628L18.9729 12.589C18.1669 12.152 17.1869 12.28 16.5569 12.906Z",
    fill: "#DBE8FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/Telephone.56f0d999ba860d0bc9fecae396012931.svg";
export { ForwardRef as ReactComponent };